"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Collar Alarm Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.33
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthCheckApi = exports.HealthCheckApiFactory = exports.HealthCheckApiFp = exports.HealthCheckApiAxiosParamCreator = exports.FarmApi = exports.FarmApiFactory = exports.FarmApiFp = exports.FarmApiAxiosParamCreator = exports.CollarEventAlarmApi = exports.CollarEventAlarmApiFactory = exports.CollarEventAlarmApiFp = exports.CollarEventAlarmApiAxiosParamCreator = exports.CollarContextApi = exports.CollarContextApiFactory = exports.CollarContextApiFp = exports.CollarContextApiAxiosParamCreator = exports.CollarAlarmSubscriptionApi = exports.CollarAlarmSubscriptionApiFactory = exports.CollarAlarmSubscriptionApiFp = exports.CollarAlarmSubscriptionApiAxiosParamCreator = exports.CollarActiveAlarmApi = exports.CollarActiveAlarmApiFactory = exports.CollarActiveAlarmApiFp = exports.CollarActiveAlarmApiAxiosParamCreator = exports.AlarmSettingsApi = exports.AlarmSettingsApiFactory = exports.AlarmSettingsApiFp = exports.AlarmSettingsApiAxiosParamCreator = exports.AlarmActionApi = exports.AlarmActionApiFactory = exports.AlarmActionApiFp = exports.AlarmActionApiAxiosParamCreator = exports.AlarmSubscriptionTypeEnum = exports.AlarmStateEnum = exports.AlarmFilterTypeEnum = exports.AlarmActionTypeEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * Type of action to be taken when the alarm is triggered.
 * @export
 * @enum {string}
 */
exports.AlarmActionTypeEnum = {
    SNOOZE: 'SNOOZE',
    REMOVE_ALARM: 'REMOVE_ALARM',
    RETURN_TO_HALTER: 'RETURN_TO_HALTER',
    RESET_COLLAR: 'RESET_COLLAR',
    POWER_OFF_COLLAR: 'POWER_OFF_COLLAR',
    TAG_OFF: 'TAG_OFF',
    CHANGE_FARM: 'CHANGE_FARM',
    DEPROVISION_COLLAR: 'DEPROVISION_COLLAR',
    TAG_ON_TO_FIND_COW: 'TAG_ON_TO_FIND_COW'
};
/**
 * Type of filter to be applied when the alarm is triggered.
 * @export
 * @enum {string}
 */
exports.AlarmFilterTypeEnum = {
    HIDE: 'HIDE',
    SNOOZE: 'SNOOZE'
};
/**
 * State of the alarm.
 * @export
 * @enum {string}
 */
exports.AlarmStateEnum = {
    ALARMED: 'ALARMED',
    RESOLVED: 'RESOLVED'
};
/**
 * Type of subscription for the alarm.
 * @export
 * @enum {string}
 */
exports.AlarmSubscriptionTypeEnum = {
    VISIBLE: 'VISIBLE',
    INVISIBLE: 'INVISIBLE'
};
/**
 * AlarmActionApi - axios parameter creator
 * @export
 */
var AlarmActionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Check and then create automated collar active alarm action by serial number if a collar active alarms context meets a settings condition.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAndCreateAutomatedCollarActiveAlarmActionBySerialNumber: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('checkAndCreateAutomatedCollarActiveAlarmActionBySerialNumber', 'serialNumber', serialNumber);
                    localVarPath = "/collar-alarm/alarm-action/active/automated/{serialNumber}"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Check and then create automated collar event alarm action by serial number if a collar event alarms context meets a settings condition.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAndCreateAutomatedCollarEventAlarmActionBySerialNumber: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('checkAndCreateAutomatedCollarEventAlarmActionBySerialNumber', 'serialNumber', serialNumber);
                    localVarPath = "/collar-alarm/alarm-action/event/automated/{serialNumber}"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create alarm action.
         * @param {ICreateCollarAlarmActionRequestDTO} [iCreateCollarAlarmActionRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlarmAction: function (iCreateCollarAlarmActionRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/collar-alarm/alarm-action";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateCollarAlarmActionRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.AlarmActionApiAxiosParamCreator = AlarmActionApiAxiosParamCreator;
/**
 * AlarmActionApi - functional programming interface
 * @export
 */
var AlarmActionApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AlarmActionApiAxiosParamCreator)(configuration);
    return {
        /**
         * Check and then create automated collar active alarm action by serial number if a collar active alarms context meets a settings condition.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAndCreateAutomatedCollarActiveAlarmActionBySerialNumber: function (serialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkAndCreateAutomatedCollarActiveAlarmActionBySerialNumber(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Check and then create automated collar event alarm action by serial number if a collar event alarms context meets a settings condition.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAndCreateAutomatedCollarEventAlarmActionBySerialNumber: function (serialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkAndCreateAutomatedCollarEventAlarmActionBySerialNumber(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create alarm action.
         * @param {ICreateCollarAlarmActionRequestDTO} [iCreateCollarAlarmActionRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlarmAction: function (iCreateCollarAlarmActionRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAlarmAction(iCreateCollarAlarmActionRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AlarmActionApiFp = AlarmActionApiFp;
/**
 * AlarmActionApi - factory interface
 * @export
 */
var AlarmActionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AlarmActionApiFp)(configuration);
    return {
        /**
         * Check and then create automated collar active alarm action by serial number if a collar active alarms context meets a settings condition.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAndCreateAutomatedCollarActiveAlarmActionBySerialNumber: function (serialNumber, options) {
            return localVarFp.checkAndCreateAutomatedCollarActiveAlarmActionBySerialNumber(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Check and then create automated collar event alarm action by serial number if a collar event alarms context meets a settings condition.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAndCreateAutomatedCollarEventAlarmActionBySerialNumber: function (serialNumber, options) {
            return localVarFp.checkAndCreateAutomatedCollarEventAlarmActionBySerialNumber(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create alarm action.
         * @param {ICreateCollarAlarmActionRequestDTO} [iCreateCollarAlarmActionRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlarmAction: function (iCreateCollarAlarmActionRequestDTO, options) {
            return localVarFp.createAlarmAction(iCreateCollarAlarmActionRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AlarmActionApiFactory = AlarmActionApiFactory;
/**
 * AlarmActionApi - object-oriented interface
 * @export
 * @class AlarmActionApi
 * @extends {BaseAPI}
 */
var AlarmActionApi = /** @class */ (function (_super) {
    __extends(AlarmActionApi, _super);
    function AlarmActionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Check and then create automated collar active alarm action by serial number if a collar active alarms context meets a settings condition.
     * @param {string} serialNumber Unique serial number of the collar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlarmActionApi
     */
    AlarmActionApi.prototype.checkAndCreateAutomatedCollarActiveAlarmActionBySerialNumber = function (serialNumber, options) {
        var _this = this;
        return (0, exports.AlarmActionApiFp)(this.configuration).checkAndCreateAutomatedCollarActiveAlarmActionBySerialNumber(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Check and then create automated collar event alarm action by serial number if a collar event alarms context meets a settings condition.
     * @param {string} serialNumber Unique serial number of the collar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlarmActionApi
     */
    AlarmActionApi.prototype.checkAndCreateAutomatedCollarEventAlarmActionBySerialNumber = function (serialNumber, options) {
        var _this = this;
        return (0, exports.AlarmActionApiFp)(this.configuration).checkAndCreateAutomatedCollarEventAlarmActionBySerialNumber(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create alarm action.
     * @param {ICreateCollarAlarmActionRequestDTO} [iCreateCollarAlarmActionRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlarmActionApi
     */
    AlarmActionApi.prototype.createAlarmAction = function (iCreateCollarAlarmActionRequestDTO, options) {
        var _this = this;
        return (0, exports.AlarmActionApiFp)(this.configuration).createAlarmAction(iCreateCollarAlarmActionRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AlarmActionApi;
}(base_1.BaseAPI));
exports.AlarmActionApi = AlarmActionApi;
/**
 * AlarmSettingsApi - axios parameter creator
 * @export
 */
var AlarmSettingsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Delete alarm settings.
         * @param {IDeleteAlarmSettingsRequestDTO} [iDeleteAlarmSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlarmSettings: function (iDeleteAlarmSettingsRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/collar-alarm/alarm-settings/delete";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDeleteAlarmSettingsRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all alarm settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAlarmSettings: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/collar-alarm/alarm-settings";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Put alarm setting.
         * @param {IPutAlarmSettingsRequestDTO} [iPutAlarmSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAlarmSettings: function (iPutAlarmSettingsRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/collar-alarm/alarm-settings";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iPutAlarmSettingsRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.AlarmSettingsApiAxiosParamCreator = AlarmSettingsApiAxiosParamCreator;
/**
 * AlarmSettingsApi - functional programming interface
 * @export
 */
var AlarmSettingsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AlarmSettingsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete alarm settings.
         * @param {IDeleteAlarmSettingsRequestDTO} [iDeleteAlarmSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlarmSettings: function (iDeleteAlarmSettingsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteAlarmSettings(iDeleteAlarmSettingsRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all alarm settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAlarmSettings: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllAlarmSettings(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Put alarm setting.
         * @param {IPutAlarmSettingsRequestDTO} [iPutAlarmSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAlarmSettings: function (iPutAlarmSettingsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.putAlarmSettings(iPutAlarmSettingsRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AlarmSettingsApiFp = AlarmSettingsApiFp;
/**
 * AlarmSettingsApi - factory interface
 * @export
 */
var AlarmSettingsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AlarmSettingsApiFp)(configuration);
    return {
        /**
         * Delete alarm settings.
         * @param {IDeleteAlarmSettingsRequestDTO} [iDeleteAlarmSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlarmSettings: function (iDeleteAlarmSettingsRequestDTO, options) {
            return localVarFp.deleteAlarmSettings(iDeleteAlarmSettingsRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all alarm settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAlarmSettings: function (options) {
            return localVarFp.getAllAlarmSettings(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Put alarm setting.
         * @param {IPutAlarmSettingsRequestDTO} [iPutAlarmSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAlarmSettings: function (iPutAlarmSettingsRequestDTO, options) {
            return localVarFp.putAlarmSettings(iPutAlarmSettingsRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AlarmSettingsApiFactory = AlarmSettingsApiFactory;
/**
 * AlarmSettingsApi - object-oriented interface
 * @export
 * @class AlarmSettingsApi
 * @extends {BaseAPI}
 */
var AlarmSettingsApi = /** @class */ (function (_super) {
    __extends(AlarmSettingsApi, _super);
    function AlarmSettingsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete alarm settings.
     * @param {IDeleteAlarmSettingsRequestDTO} [iDeleteAlarmSettingsRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlarmSettingsApi
     */
    AlarmSettingsApi.prototype.deleteAlarmSettings = function (iDeleteAlarmSettingsRequestDTO, options) {
        var _this = this;
        return (0, exports.AlarmSettingsApiFp)(this.configuration).deleteAlarmSettings(iDeleteAlarmSettingsRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all alarm settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlarmSettingsApi
     */
    AlarmSettingsApi.prototype.getAllAlarmSettings = function (options) {
        var _this = this;
        return (0, exports.AlarmSettingsApiFp)(this.configuration).getAllAlarmSettings(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Put alarm setting.
     * @param {IPutAlarmSettingsRequestDTO} [iPutAlarmSettingsRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlarmSettingsApi
     */
    AlarmSettingsApi.prototype.putAlarmSettings = function (iPutAlarmSettingsRequestDTO, options) {
        var _this = this;
        return (0, exports.AlarmSettingsApiFp)(this.configuration).putAlarmSettings(iPutAlarmSettingsRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AlarmSettingsApi;
}(base_1.BaseAPI));
exports.AlarmSettingsApi = AlarmSettingsApi;
/**
 * CollarActiveAlarmApi - axios parameter creator
 * @export
 */
var CollarActiveAlarmApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create collar active alarm.
         * @param {ICreateCollarActiveAlarmRequestDTO} iCreateCollarActiveAlarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollarActiveAlarm: function (iCreateCollarActiveAlarmRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iCreateCollarActiveAlarmRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('createCollarActiveAlarm', 'iCreateCollarActiveAlarmRequestDTO', iCreateCollarActiveAlarmRequestDTO);
                    localVarPath = "/collar-alarm/collar-alarm/active";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateCollarActiveAlarmRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete collar active alarm.
         * @param {string} serialNumber Unique serial number of the collar active alarm.
         * @param {string} alarmType Type of the alarm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCollarActiveAlarmBySerialNumberAndAlarmType: function (serialNumber, alarmType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCollarActiveAlarmBySerialNumberAndAlarmType', 'serialNumber', serialNumber);
                    // verify required parameter 'alarmType' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCollarActiveAlarmBySerialNumberAndAlarmType', 'alarmType', alarmType);
                    localVarPath = "/collar-alarm/collar-alarm/active/{serialNumber}/{alarmType}"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)))
                        .replace("{".concat("alarmType", "}"), encodeURIComponent(String(alarmType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get collar active alarms context with action required.
         * @param {string} [nextSerialNumber] Serial number of the next collar active alarms context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionRequiredCollarActiveAlarmsContexts: function (nextSerialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/collar-alarm/collar-alarm/active/context/action-required/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (nextSerialNumber !== undefined) {
                        localVarQueryParameter['nextSerialNumber'] = nextSerialNumber;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all action required active collar alarms by farm id.  NOTE: Snooze alarms will not be filtered in this case.
         * @param {string} farmId Unique id of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActionRequiredActiveCollarAlarmsByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllActionRequiredActiveCollarAlarmsByFarmID', 'farmId', farmId);
                    localVarPath = "/collar-alarm/collar-alarm/active/action-required/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update collar active alarms by farm id.
         * @param {string} serialNumber Unique serial number of the collar active alarm.
         * @param {string} [farmId] Unique id of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAllCollarActiveAlarmFarmIDBySerialNumber: function (serialNumber, farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('updateAllCollarActiveAlarmFarmIDBySerialNumber', 'serialNumber', serialNumber);
                    localVarPath = "/collar-alarm/collar-alarm/active/{serialNumber}/farm"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (farmId !== undefined) {
                        localVarQueryParameter['farmId'] = farmId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CollarActiveAlarmApiAxiosParamCreator = CollarActiveAlarmApiAxiosParamCreator;
/**
 * CollarActiveAlarmApi - functional programming interface
 * @export
 */
var CollarActiveAlarmApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CollarActiveAlarmApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create collar active alarm.
         * @param {ICreateCollarActiveAlarmRequestDTO} iCreateCollarActiveAlarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollarActiveAlarm: function (iCreateCollarActiveAlarmRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCollarActiveAlarm(iCreateCollarActiveAlarmRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete collar active alarm.
         * @param {string} serialNumber Unique serial number of the collar active alarm.
         * @param {string} alarmType Type of the alarm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCollarActiveAlarmBySerialNumberAndAlarmType: function (serialNumber, alarmType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCollarActiveAlarmBySerialNumberAndAlarmType(serialNumber, alarmType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get collar active alarms context with action required.
         * @param {string} [nextSerialNumber] Serial number of the next collar active alarms context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionRequiredCollarActiveAlarmsContexts: function (nextSerialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getActionRequiredCollarActiveAlarmsContexts(nextSerialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all action required active collar alarms by farm id.  NOTE: Snooze alarms will not be filtered in this case.
         * @param {string} farmId Unique id of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActionRequiredActiveCollarAlarmsByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllActionRequiredActiveCollarAlarmsByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update collar active alarms by farm id.
         * @param {string} serialNumber Unique serial number of the collar active alarm.
         * @param {string} [farmId] Unique id of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAllCollarActiveAlarmFarmIDBySerialNumber: function (serialNumber, farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateAllCollarActiveAlarmFarmIDBySerialNumber(serialNumber, farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CollarActiveAlarmApiFp = CollarActiveAlarmApiFp;
/**
 * CollarActiveAlarmApi - factory interface
 * @export
 */
var CollarActiveAlarmApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CollarActiveAlarmApiFp)(configuration);
    return {
        /**
         * Create collar active alarm.
         * @param {ICreateCollarActiveAlarmRequestDTO} iCreateCollarActiveAlarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollarActiveAlarm: function (iCreateCollarActiveAlarmRequestDTO, options) {
            return localVarFp.createCollarActiveAlarm(iCreateCollarActiveAlarmRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete collar active alarm.
         * @param {string} serialNumber Unique serial number of the collar active alarm.
         * @param {string} alarmType Type of the alarm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCollarActiveAlarmBySerialNumberAndAlarmType: function (serialNumber, alarmType, options) {
            return localVarFp.deleteCollarActiveAlarmBySerialNumberAndAlarmType(serialNumber, alarmType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get collar active alarms context with action required.
         * @param {string} [nextSerialNumber] Serial number of the next collar active alarms context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionRequiredCollarActiveAlarmsContexts: function (nextSerialNumber, options) {
            return localVarFp.getActionRequiredCollarActiveAlarmsContexts(nextSerialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all action required active collar alarms by farm id.  NOTE: Snooze alarms will not be filtered in this case.
         * @param {string} farmId Unique id of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActionRequiredActiveCollarAlarmsByFarmID: function (farmId, options) {
            return localVarFp.getAllActionRequiredActiveCollarAlarmsByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update collar active alarms by farm id.
         * @param {string} serialNumber Unique serial number of the collar active alarm.
         * @param {string} [farmId] Unique id of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAllCollarActiveAlarmFarmIDBySerialNumber: function (serialNumber, farmId, options) {
            return localVarFp.updateAllCollarActiveAlarmFarmIDBySerialNumber(serialNumber, farmId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CollarActiveAlarmApiFactory = CollarActiveAlarmApiFactory;
/**
 * CollarActiveAlarmApi - object-oriented interface
 * @export
 * @class CollarActiveAlarmApi
 * @extends {BaseAPI}
 */
var CollarActiveAlarmApi = /** @class */ (function (_super) {
    __extends(CollarActiveAlarmApi, _super);
    function CollarActiveAlarmApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create collar active alarm.
     * @param {ICreateCollarActiveAlarmRequestDTO} iCreateCollarActiveAlarmRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollarActiveAlarmApi
     */
    CollarActiveAlarmApi.prototype.createCollarActiveAlarm = function (iCreateCollarActiveAlarmRequestDTO, options) {
        var _this = this;
        return (0, exports.CollarActiveAlarmApiFp)(this.configuration).createCollarActiveAlarm(iCreateCollarActiveAlarmRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete collar active alarm.
     * @param {string} serialNumber Unique serial number of the collar active alarm.
     * @param {string} alarmType Type of the alarm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollarActiveAlarmApi
     */
    CollarActiveAlarmApi.prototype.deleteCollarActiveAlarmBySerialNumberAndAlarmType = function (serialNumber, alarmType, options) {
        var _this = this;
        return (0, exports.CollarActiveAlarmApiFp)(this.configuration).deleteCollarActiveAlarmBySerialNumberAndAlarmType(serialNumber, alarmType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get collar active alarms context with action required.
     * @param {string} [nextSerialNumber] Serial number of the next collar active alarms context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollarActiveAlarmApi
     */
    CollarActiveAlarmApi.prototype.getActionRequiredCollarActiveAlarmsContexts = function (nextSerialNumber, options) {
        var _this = this;
        return (0, exports.CollarActiveAlarmApiFp)(this.configuration).getActionRequiredCollarActiveAlarmsContexts(nextSerialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all action required active collar alarms by farm id.  NOTE: Snooze alarms will not be filtered in this case.
     * @param {string} farmId Unique id of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollarActiveAlarmApi
     */
    CollarActiveAlarmApi.prototype.getAllActionRequiredActiveCollarAlarmsByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.CollarActiveAlarmApiFp)(this.configuration).getAllActionRequiredActiveCollarAlarmsByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update collar active alarms by farm id.
     * @param {string} serialNumber Unique serial number of the collar active alarm.
     * @param {string} [farmId] Unique id of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollarActiveAlarmApi
     */
    CollarActiveAlarmApi.prototype.updateAllCollarActiveAlarmFarmIDBySerialNumber = function (serialNumber, farmId, options) {
        var _this = this;
        return (0, exports.CollarActiveAlarmApiFp)(this.configuration).updateAllCollarActiveAlarmFarmIDBySerialNumber(serialNumber, farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CollarActiveAlarmApi;
}(base_1.BaseAPI));
exports.CollarActiveAlarmApi = CollarActiveAlarmApi;
/**
 * CollarAlarmSubscriptionApi - axios parameter creator
 * @export
 */
var CollarAlarmSubscriptionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create collar alarm subscription
         * @param {ICreateCollarAlarmSubscriptionRequestDTO} [iCreateCollarAlarmSubscriptionRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollarAlarmSubscription: function (iCreateCollarAlarmSubscriptionRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/collar-alarm/alarm-subscription";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateCollarAlarmSubscriptionRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CollarAlarmSubscriptionApiAxiosParamCreator = CollarAlarmSubscriptionApiAxiosParamCreator;
/**
 * CollarAlarmSubscriptionApi - functional programming interface
 * @export
 */
var CollarAlarmSubscriptionApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CollarAlarmSubscriptionApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create collar alarm subscription
         * @param {ICreateCollarAlarmSubscriptionRequestDTO} [iCreateCollarAlarmSubscriptionRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollarAlarmSubscription: function (iCreateCollarAlarmSubscriptionRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCollarAlarmSubscription(iCreateCollarAlarmSubscriptionRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CollarAlarmSubscriptionApiFp = CollarAlarmSubscriptionApiFp;
/**
 * CollarAlarmSubscriptionApi - factory interface
 * @export
 */
var CollarAlarmSubscriptionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CollarAlarmSubscriptionApiFp)(configuration);
    return {
        /**
         * Create collar alarm subscription
         * @param {ICreateCollarAlarmSubscriptionRequestDTO} [iCreateCollarAlarmSubscriptionRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollarAlarmSubscription: function (iCreateCollarAlarmSubscriptionRequestDTO, options) {
            return localVarFp.createCollarAlarmSubscription(iCreateCollarAlarmSubscriptionRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CollarAlarmSubscriptionApiFactory = CollarAlarmSubscriptionApiFactory;
/**
 * CollarAlarmSubscriptionApi - object-oriented interface
 * @export
 * @class CollarAlarmSubscriptionApi
 * @extends {BaseAPI}
 */
var CollarAlarmSubscriptionApi = /** @class */ (function (_super) {
    __extends(CollarAlarmSubscriptionApi, _super);
    function CollarAlarmSubscriptionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create collar alarm subscription
     * @param {ICreateCollarAlarmSubscriptionRequestDTO} [iCreateCollarAlarmSubscriptionRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollarAlarmSubscriptionApi
     */
    CollarAlarmSubscriptionApi.prototype.createCollarAlarmSubscription = function (iCreateCollarAlarmSubscriptionRequestDTO, options) {
        var _this = this;
        return (0, exports.CollarAlarmSubscriptionApiFp)(this.configuration).createCollarAlarmSubscription(iCreateCollarAlarmSubscriptionRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CollarAlarmSubscriptionApi;
}(base_1.BaseAPI));
exports.CollarAlarmSubscriptionApi = CollarAlarmSubscriptionApi;
/**
 * CollarContextApi - axios parameter creator
 * @export
 */
var CollarContextApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create collar context.
         * @param {ICreateCollarContextRequestDTO} [iCreateCollarContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollarContext: function (iCreateCollarContextRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/collar-alarm/collar-context";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateCollarContextRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete collar context by serial number.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCollarContextBySerialNumber: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCollarContextBySerialNumber', 'serialNumber', serialNumber);
                    localVarPath = "/collar-alarm/collar-context/{serialNumber}"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get collar context by serial number.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollarContextBySerialNumber: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('getCollarContextBySerialNumber', 'serialNumber', serialNumber);
                    localVarPath = "/collar-alarm/collar-context/{serialNumber}"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update collar context by serial number.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {IUpdateCollarContextRequestDTO} [iUpdateCollarContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCollarContextBySerialNumber: function (serialNumber, iUpdateCollarContextRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('updateCollarContextBySerialNumber', 'serialNumber', serialNumber);
                    localVarPath = "/collar-alarm/collar-context/{serialNumber}"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateCollarContextRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update collar on farm status by serial number.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {IUpdateCollarContextOnFarmStatusRequestDTO} [iUpdateCollarContextOnFarmStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCollarContextOnFarmStatusBySerialNumber: function (serialNumber, iUpdateCollarContextOnFarmStatusRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('updateCollarContextOnFarmStatusBySerialNumber', 'serialNumber', serialNumber);
                    localVarPath = "/collar-alarm/collar-context/{serialNumber}/on-farm-status"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateCollarContextOnFarmStatusRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CollarContextApiAxiosParamCreator = CollarContextApiAxiosParamCreator;
/**
 * CollarContextApi - functional programming interface
 * @export
 */
var CollarContextApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CollarContextApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create collar context.
         * @param {ICreateCollarContextRequestDTO} [iCreateCollarContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollarContext: function (iCreateCollarContextRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCollarContext(iCreateCollarContextRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete collar context by serial number.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCollarContextBySerialNumber: function (serialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCollarContextBySerialNumber(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get collar context by serial number.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollarContextBySerialNumber: function (serialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCollarContextBySerialNumber(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update collar context by serial number.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {IUpdateCollarContextRequestDTO} [iUpdateCollarContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCollarContextBySerialNumber: function (serialNumber, iUpdateCollarContextRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCollarContextBySerialNumber(serialNumber, iUpdateCollarContextRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update collar on farm status by serial number.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {IUpdateCollarContextOnFarmStatusRequestDTO} [iUpdateCollarContextOnFarmStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCollarContextOnFarmStatusBySerialNumber: function (serialNumber, iUpdateCollarContextOnFarmStatusRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCollarContextOnFarmStatusBySerialNumber(serialNumber, iUpdateCollarContextOnFarmStatusRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CollarContextApiFp = CollarContextApiFp;
/**
 * CollarContextApi - factory interface
 * @export
 */
var CollarContextApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CollarContextApiFp)(configuration);
    return {
        /**
         * Create collar context.
         * @param {ICreateCollarContextRequestDTO} [iCreateCollarContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollarContext: function (iCreateCollarContextRequestDTO, options) {
            return localVarFp.createCollarContext(iCreateCollarContextRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete collar context by serial number.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCollarContextBySerialNumber: function (serialNumber, options) {
            return localVarFp.deleteCollarContextBySerialNumber(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get collar context by serial number.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollarContextBySerialNumber: function (serialNumber, options) {
            return localVarFp.getCollarContextBySerialNumber(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update collar context by serial number.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {IUpdateCollarContextRequestDTO} [iUpdateCollarContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCollarContextBySerialNumber: function (serialNumber, iUpdateCollarContextRequestDTO, options) {
            return localVarFp.updateCollarContextBySerialNumber(serialNumber, iUpdateCollarContextRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update collar on farm status by serial number.
         * @param {string} serialNumber Unique serial number of the collar.
         * @param {IUpdateCollarContextOnFarmStatusRequestDTO} [iUpdateCollarContextOnFarmStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCollarContextOnFarmStatusBySerialNumber: function (serialNumber, iUpdateCollarContextOnFarmStatusRequestDTO, options) {
            return localVarFp.updateCollarContextOnFarmStatusBySerialNumber(serialNumber, iUpdateCollarContextOnFarmStatusRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CollarContextApiFactory = CollarContextApiFactory;
/**
 * CollarContextApi - object-oriented interface
 * @export
 * @class CollarContextApi
 * @extends {BaseAPI}
 */
var CollarContextApi = /** @class */ (function (_super) {
    __extends(CollarContextApi, _super);
    function CollarContextApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create collar context.
     * @param {ICreateCollarContextRequestDTO} [iCreateCollarContextRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollarContextApi
     */
    CollarContextApi.prototype.createCollarContext = function (iCreateCollarContextRequestDTO, options) {
        var _this = this;
        return (0, exports.CollarContextApiFp)(this.configuration).createCollarContext(iCreateCollarContextRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete collar context by serial number.
     * @param {string} serialNumber Unique serial number of the collar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollarContextApi
     */
    CollarContextApi.prototype.deleteCollarContextBySerialNumber = function (serialNumber, options) {
        var _this = this;
        return (0, exports.CollarContextApiFp)(this.configuration).deleteCollarContextBySerialNumber(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get collar context by serial number.
     * @param {string} serialNumber Unique serial number of the collar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollarContextApi
     */
    CollarContextApi.prototype.getCollarContextBySerialNumber = function (serialNumber, options) {
        var _this = this;
        return (0, exports.CollarContextApiFp)(this.configuration).getCollarContextBySerialNumber(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update collar context by serial number.
     * @param {string} serialNumber Unique serial number of the collar.
     * @param {IUpdateCollarContextRequestDTO} [iUpdateCollarContextRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollarContextApi
     */
    CollarContextApi.prototype.updateCollarContextBySerialNumber = function (serialNumber, iUpdateCollarContextRequestDTO, options) {
        var _this = this;
        return (0, exports.CollarContextApiFp)(this.configuration).updateCollarContextBySerialNumber(serialNumber, iUpdateCollarContextRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update collar on farm status by serial number.
     * @param {string} serialNumber Unique serial number of the collar.
     * @param {IUpdateCollarContextOnFarmStatusRequestDTO} [iUpdateCollarContextOnFarmStatusRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollarContextApi
     */
    CollarContextApi.prototype.updateCollarContextOnFarmStatusBySerialNumber = function (serialNumber, iUpdateCollarContextOnFarmStatusRequestDTO, options) {
        var _this = this;
        return (0, exports.CollarContextApiFp)(this.configuration).updateCollarContextOnFarmStatusBySerialNumber(serialNumber, iUpdateCollarContextOnFarmStatusRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CollarContextApi;
}(base_1.BaseAPI));
exports.CollarContextApi = CollarContextApi;
/**
 * CollarEventAlarmApi - axios parameter creator
 * @export
 */
var CollarEventAlarmApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create collar event alarm.
         * @param {ICreateCollarEventAlarmRequestDTO} iCreateCollarEventAlarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollarEventAlarm: function (iCreateCollarEventAlarmRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iCreateCollarEventAlarmRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('createCollarEventAlarm', 'iCreateCollarEventAlarmRequestDTO', iCreateCollarEventAlarmRequestDTO);
                    localVarPath = "/collar-alarm/collar-alarm/event";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateCollarEventAlarmRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get collar event alarms contexts.
         * @param {string} [nextSerialNumber] Serial number of the next collar event alarms context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollarEventAlarmsContexts: function (nextSerialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/collar-alarm/collar-alarm/event";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (nextSerialNumber !== undefined) {
                        localVarQueryParameter['nextSerialNumber'] = nextSerialNumber;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CollarEventAlarmApiAxiosParamCreator = CollarEventAlarmApiAxiosParamCreator;
/**
 * CollarEventAlarmApi - functional programming interface
 * @export
 */
var CollarEventAlarmApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CollarEventAlarmApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create collar event alarm.
         * @param {ICreateCollarEventAlarmRequestDTO} iCreateCollarEventAlarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollarEventAlarm: function (iCreateCollarEventAlarmRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCollarEventAlarm(iCreateCollarEventAlarmRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get collar event alarms contexts.
         * @param {string} [nextSerialNumber] Serial number of the next collar event alarms context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollarEventAlarmsContexts: function (nextSerialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCollarEventAlarmsContexts(nextSerialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CollarEventAlarmApiFp = CollarEventAlarmApiFp;
/**
 * CollarEventAlarmApi - factory interface
 * @export
 */
var CollarEventAlarmApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CollarEventAlarmApiFp)(configuration);
    return {
        /**
         * Create collar event alarm.
         * @param {ICreateCollarEventAlarmRequestDTO} iCreateCollarEventAlarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollarEventAlarm: function (iCreateCollarEventAlarmRequestDTO, options) {
            return localVarFp.createCollarEventAlarm(iCreateCollarEventAlarmRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get collar event alarms contexts.
         * @param {string} [nextSerialNumber] Serial number of the next collar event alarms context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollarEventAlarmsContexts: function (nextSerialNumber, options) {
            return localVarFp.getCollarEventAlarmsContexts(nextSerialNumber, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CollarEventAlarmApiFactory = CollarEventAlarmApiFactory;
/**
 * CollarEventAlarmApi - object-oriented interface
 * @export
 * @class CollarEventAlarmApi
 * @extends {BaseAPI}
 */
var CollarEventAlarmApi = /** @class */ (function (_super) {
    __extends(CollarEventAlarmApi, _super);
    function CollarEventAlarmApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create collar event alarm.
     * @param {ICreateCollarEventAlarmRequestDTO} iCreateCollarEventAlarmRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollarEventAlarmApi
     */
    CollarEventAlarmApi.prototype.createCollarEventAlarm = function (iCreateCollarEventAlarmRequestDTO, options) {
        var _this = this;
        return (0, exports.CollarEventAlarmApiFp)(this.configuration).createCollarEventAlarm(iCreateCollarEventAlarmRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get collar event alarms contexts.
     * @param {string} [nextSerialNumber] Serial number of the next collar event alarms context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollarEventAlarmApi
     */
    CollarEventAlarmApi.prototype.getCollarEventAlarmsContexts = function (nextSerialNumber, options) {
        var _this = this;
        return (0, exports.CollarEventAlarmApiFp)(this.configuration).getCollarEventAlarmsContexts(nextSerialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CollarEventAlarmApi;
}(base_1.BaseAPI));
exports.CollarEventAlarmApi = CollarEventAlarmApi;
/**
 * FarmApi - axios parameter creator
 * @export
 */
var FarmApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Delete farm metadata by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmMetadataByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteFarmMetadataByID', 'id', id);
                    localVarPath = "/collar-alarm/farm/metadata/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get farm metadata by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmMetadataByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getFarmMetadataByID', 'id', id);
                    localVarPath = "/collar-alarm/farm/metadata/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Put farm metadata.
         * @param {IFarmMetadataDTO} [iFarmMetadataDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFarmMetadata: function (iFarmMetadataDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/collar-alarm/farm/metadata";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iFarmMetadataDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FarmApiAxiosParamCreator = FarmApiAxiosParamCreator;
/**
 * FarmApi - functional programming interface
 * @export
 */
var FarmApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FarmApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete farm metadata by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmMetadataByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFarmMetadataByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get farm metadata by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmMetadataByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFarmMetadataByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Put farm metadata.
         * @param {IFarmMetadataDTO} [iFarmMetadataDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFarmMetadata: function (iFarmMetadataDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.putFarmMetadata(iFarmMetadataDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FarmApiFp = FarmApiFp;
/**
 * FarmApi - factory interface
 * @export
 */
var FarmApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FarmApiFp)(configuration);
    return {
        /**
         * Delete farm metadata by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmMetadataByID: function (id, options) {
            return localVarFp.deleteFarmMetadataByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get farm metadata by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmMetadataByID: function (id, options) {
            return localVarFp.getFarmMetadataByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Put farm metadata.
         * @param {IFarmMetadataDTO} [iFarmMetadataDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFarmMetadata: function (iFarmMetadataDTO, options) {
            return localVarFp.putFarmMetadata(iFarmMetadataDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FarmApiFactory = FarmApiFactory;
/**
 * FarmApi - object-oriented interface
 * @export
 * @class FarmApi
 * @extends {BaseAPI}
 */
var FarmApi = /** @class */ (function (_super) {
    __extends(FarmApi, _super);
    function FarmApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete farm metadata by ID.
     * @param {string} id Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.deleteFarmMetadataByID = function (id, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).deleteFarmMetadataByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get farm metadata by ID.
     * @param {string} id Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.getFarmMetadataByID = function (id, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).getFarmMetadataByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Put farm metadata.
     * @param {IFarmMetadataDTO} [iFarmMetadataDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.putFarmMetadata = function (iFarmMetadataDTO, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).putFarmMetadata(iFarmMetadataDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FarmApi;
}(base_1.BaseAPI));
exports.FarmApi = FarmApi;
/**
 * HealthCheckApi - axios parameter creator
 * @export
 */
var HealthCheckApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/collar-alarm/health-check";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.HealthCheckApiAxiosParamCreator = HealthCheckApiAxiosParamCreator;
/**
 * HealthCheckApi - functional programming interface
 * @export
 */
var HealthCheckApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HealthCheckApiAxiosParamCreator)(configuration);
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkHealth(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.HealthCheckApiFp = HealthCheckApiFp;
/**
 * HealthCheckApi - factory interface
 * @export
 */
var HealthCheckApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HealthCheckApiFp)(configuration);
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            return localVarFp.checkHealth(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HealthCheckApiFactory = HealthCheckApiFactory;
/**
 * HealthCheckApi - object-oriented interface
 * @export
 * @class HealthCheckApi
 * @extends {BaseAPI}
 */
var HealthCheckApi = /** @class */ (function (_super) {
    __extends(HealthCheckApi, _super);
    function HealthCheckApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Check service health.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    HealthCheckApi.prototype.checkHealth = function (options) {
        var _this = this;
        return (0, exports.HealthCheckApiFp)(this.configuration).checkHealth(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HealthCheckApi;
}(base_1.BaseAPI));
exports.HealthCheckApi = HealthCheckApi;
